module.exports = __webpack_public_path__ + "img/T6-C-xh_10.f85396e2.png";